import { render, staticRenderFns } from "./CutConfig.vue?vue&type=template&id=2b8f271b&"
import script from "./CutConfig.vue?vue&type=script&lang=js&"
export * from "./CutConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports